<template>
    <div id="sidebar-guest" class="sidebar-wrapper">
        <div id="nav-wrapper" v-if="init">
            <nav id="nav">
                <div id="nav-header">
                    <template v-if="(accountInvite && accountInvite.logo_url) || (!accountInvite && init.auth_user.company.logo_url)">
                        <div id="company-logo">
                          <template v-if="accountInvite">
                            <img :src="accountInvite.logo_url" :alt="accountInvite.company" />
                          </template>
                          <template v-else>
                            <img :src="init.auth_user.company.logo_url" :alt="init.auth_user.company.name" />
                          </template>
                        </div>
                        <div class="powered-by"><span>Powered By</span></div>
                    </template>
                </div>

                <router-link to="/" :title="title">
                    <logo />
                </router-link>

                <div class="nav-widget">
                    <h6>Welcome</h6>
                    <p>Interested in reconciling and organizing your submission data like this?</p>
                    <br />
                    <p><strong>Griptiller, LLC</strong></p>
                    <p><a href="tel:+16174097500">617-409-7500</a></p>
                    <p><a href="mailto:admin@griptiller.com">admin@griptiller.com</a></p>
                </div>

                <a href="https://www.griptiller.com/" id="learn-more" class="button is-primary" target="_blank">
                    Learn More About Griptiller
                </a>
            </nav>
        </div>
    </div>
</template>

<script>
import Logo from '../Icons/Logo'
import { mapState, mapGetters } from 'vuex'
import { AUTH_LOGOUT } from '../../store/actions/auth'

export default {
  name: 'Sidebar',
  data () {
    return {
      title: process.env.NAME
    }
  },
  components: {
    'logo': Logo
  },
  computed: {
    ...mapState({
      navIsExpanded: 'navIsExpanded',
      init: state => state.init.all
    }),
    ...mapGetters({
      pusher: 'pusher/init',
      accountInvite: 'accountInvite'
    })
  },
  methods: {
    commitMutation (mutation) {
      this.$store.commit(mutation)
    },
    logout: function () {
      if (this.pusher) {
        this.pusher.allChannels()
          .forEach(channel => this.pusher.unsubscribe(channel.name))
      }

      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss">
#learn-more {
    font-size: .85em;
    margin: 15px;
    width: 85%;
    background: #274373 !important;
    border-bottom-color: #223a62 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav/GuestSidebar.vue